import { init as initApm, ApmBase } from "@elastic/apm-rum";

const hostname = window.location.hostname;
const isLocalEnv = hostname === 'localhost' || hostname === '127.0.0.1';

export const apm = initApm({
  active: !isLocalEnv,
  apiVersion: 3,

  serviceName: "isg-platform-frontend",
  serviceVersion: "1.0.0",
  serverUrl: "https://test-app.isgplatform.com/apm",
  environment: "test",

  instrument: true,

  logLevel: "debug",

  breakdownMetrics: true,

  flushInterval: 500,

  pageLoadTransactionName: window.location.pathname,

  distributedTracing: true,
  distributedTracingOrigins: [
    window.location.origin,
    "https://test-app.isgplatform.com",
    "https://test-api.isgplatform.com",
  ],

  propagateTracestate: true,

  transactionSampleRate: 1.0,

  centralConfig: true,

  eventsLimit: 500,
  queueLimit: 200,

  sendCredentials: true,

  apmRequest: (req) => {
    if (req.url.includes("/intake/v2/rum/events")) {
        return true;
    }
    return true;
    }
});